var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#00A910"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9976 7.27998C17.9096 7.19126 17.8049 7.12085 17.6896 7.07279C17.5742 7.02474 17.4505 7 17.3256 7C17.2006 7 17.0769 7.02474 16.9616 7.07279C16.8462 7.12085 16.7415 7.19126 16.6535 7.27998L9.60193 14.3411L6.63931 11.369C6.54795 11.2807 6.4401 11.2113 6.32192 11.1647C6.20374 11.1182 6.07755 11.0953 5.95054 11.0975C5.82354 11.0997 5.69821 11.1269 5.58171 11.1776C5.46521 11.2282 5.35983 11.3013 5.27158 11.3926C5.18333 11.484 5.11393 11.5918 5.06736 11.71C5.02079 11.8282 4.99795 11.9544 5.00014 12.0814C5.00234 12.2084 5.02953 12.3337 5.08017 12.4502C5.1308 12.5667 5.20388 12.6721 5.29524 12.7604L8.92989 16.395C9.01789 16.4837 9.12257 16.5541 9.23792 16.6022C9.35326 16.6502 9.47697 16.675 9.60193 16.675C9.72688 16.675 9.8506 16.6502 9.96594 16.6022C10.0813 16.5541 10.186 16.4837 10.274 16.395L17.9976 8.67137C18.0937 8.58274 18.1703 8.47516 18.2228 8.35543C18.2752 8.23569 18.3023 8.10639 18.3023 7.97568C18.3023 7.84496 18.2752 7.71566 18.2228 7.59592C18.1703 7.47619 18.0937 7.36861 17.9976 7.27998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.a4b92635f4b4a01f8b07f49a20a4bc04.svg";
export { ForwardRef as ReactComponent };